import React, { useState } from 'react';
import classnames from 'classnames';
// styles
import styles from './styles.module.scss';
import { isTextWrapped } from '@/utils/helpers';

const MIN_CHAR_LENGTH_FOR_P5_TEXT = 45;

const FieldLabel = props => {
  const { value, className, isMandatory = false } = props;
  const [
    isTextWrappingOrMoreThanThresholdChars,
    setIsTextWrappingOrMoreThanThresholdChars,
  ] = useState(false);
  const labelRef = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    if (labelRef.current) {
      const value =
        isTextWrapped(labelRef.current) ||
        labelRef.current.innerText?.length > MIN_CHAR_LENGTH_FOR_P5_TEXT;
      setIsTextWrappingOrMoreThanThresholdChars(value);
    }
  }, [labelRef.current]);

  return (
    <>
      <div className={styles.labelWrapper}>
        <span className={isMandatory ? styles.isMandatory : ''}>
          <label
            ref={labelRef}
            className={classnames(styles.fieldLabel, {
              [styles[className]]: !!className,
              [styles['P5Text']]: isTextWrappingOrMoreThanThresholdChars,
            })}
          >
            {value}
          </label>
        </span>
      </div>
    </>
  );
};

export default FieldLabel;
